import { RectangleGroupIcon } from '@heroicons/react/24/outline'

import Breadcrumb from '@/components/navigation/Breadcrumb'

import { FiltersRow } from './filters/FiltersRow'
import { getColumns } from './table/Columns'
import { DataTable } from './table/DataTable'
import { TableContextProvider } from './table/TableContext'
import { useState } from 'react'
import { Company } from '@/interfaces/company'

export default function CompanyList() {
  const [showEditCompany, setShowEditCompany] = useState(false)
  const [showDeleteCompany, setShowDeleteCompany] = useState(false)
  const [companyToEdit, setCompanyToEdit] = useState<Company>()
  const [companyToDelete, setCompanyToDelete] = useState<number>()

  return (
    <div>
      <Breadcrumb
        icon={<RectangleGroupIcon className="h-6 text-gray-500" />}
        paths={[{ name: 'Logística' }, { name: 'Compañías' }]}
      />
      <FiltersRow />
      <TableContextProvider>
        <DataTable
          columns={getColumns(
            setShowEditCompany,
            setCompanyToEdit,
            setShowDeleteCompany,
            setCompanyToDelete
          )}
          companyToDelete={companyToDelete}
          companyToEdit={companyToEdit}
          onClose={() => setShowEditCompany(false)}
          onCloseDelete={() => setShowDeleteCompany(false)}
          showDeleteCompany={showDeleteCompany}
          showEditCompany={showEditCompany}
        />
      </TableContextProvider>
    </div>
  )
}
